import * as React from 'react';

import pickInputElementProps from 'utils/pickInputElementProps';

import './styles/AutosizeInput.scss';

type Props = {
  onChange: () => void;
  placeholder: string;
};

type State = {
  size: number;
};

const getStateFromProps = (props: Props) => ({
  size: props.placeholder.length + 1,
});

class AutosizeInput extends React.Component<Props, State> {
  static defaultProps = {
    placeholder: '',
  };

  constructor(props: Props) {
    super(props);
    this.state = getStateFromProps(props);
  }

  componentWillReceiveProps(newProps: Props) {
    if (this.props.placeholder !== newProps.placeholder) {
      this.setState({ size: newProps.placeholder.length + 1 });
    }
  }

  handleChange = () => {
    const value = (this.refs.input as HTMLInputElement).value;
    if (value.length === 0) {
      this.setState(getStateFromProps(this.props));
    } else {
      this.setState({ size: value.length + 1 });
    }
    this.props.onChange();
  };

  render() {
    const props = pickInputElementProps(this.props);

    return <input {...props} ref="input" size={this.state.size} onChange={this.handleChange} />;
  }
}

export default AutosizeInput;
